export default __webpack_public_path__ + "static/media/98-16_header_invoice.de17990f.png";